<template>
  <div class="container container_mobile">
    <div
      class="loader"
      v-if="!infoLoaded"
    >
    </div>
    <div class="grid grid_h-center grid_v-margins" v-else>
      <div class="grid__col grid__col_lg-24 grid__col_xl-20">
        <div class="block block_wide" ref="block">
          <div class="block__item block__intro" v-if="!hasMembers">
            <div class="block__intro-item block__intro-item_md">
              <h2>{{ $t('startList.title') }}</h2>
            </div>
            <div class="block__intro-item block__intro-item_md">
              <section class="empty-state">
                <div class="section__group mt-0">
                  <div class="section__item">
                    <img :src="themeImages['opened']" alt="">
                  </div>
                  <div class="section__item">
                    <div class="text-lg">
                      <b v-html="$t('startList.beFirstTitle')"></b>
                    </div>
                  </div>
                </div>
                <div class="section__group">
                  <Button
                    variant="primary"
                    size="lg"
                    v-open-modal="{ name: 'reg-modal' }"
                    :text="$t('race.registration')"
                    icon-right="right"
                  ></Button>
                </div>
              </section>
            </div>
          </div>
          <template v-else>
            <div class="block__item block__intro">
              <div class="block__intro-item block__intro-item_md">
                <h2>{{ $t('startList.title') }}</h2>
              </div>
              <div class="block__intro-item block__intro-item_md">
                <div class="form">
                  <div class="grid grid_v-margins">
                    <div class="event-competitions grid__col grid__col_24 grid__col_sm-auto">
                      <div class="form__field">
                        <div class="field">
                          <div class="field__label">
                            <label class="label">{{ $t('startList.competitionLabel') }}</label>
                          </div>
                          <div class="field__input">
                            <Select
                              class="multiselect_wrap"
                              v-model="filters.competition.val"
                              :value="filters.competition.val"
                              :options="filters.competition.options"
                              @input="onFiltersChange"
                            ></Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="grid__col grid__col_stretch">
                      <div class="form__field">
                        <div class="field">
                          <div class="field__label">
                            <label class="label">{{ $t('startList.searchLabel') }}</label>
                          </div>
                          <div class="field__input">
                            <label class="input">
                              <div class="input__icons">
                                <div class="input__icon">
                                  <icon icon-name="search"></icon>
                                </div>
                              </div>
                              <input
                                v-model.trim="filters.search.val"
                                class="input__el"
                                type="text"
                                name="member_name"
                                :placeholder="$t('startList.searchPlaceholder')"
                                autocomplete="off"
                              >
                              <div class="input__icons" v-show="filters.search.val">
                                <button
                                  class="input__icon input__icon_hover"
                                  @click="clearSearch"
                                  type="button"
                                >
                                  <icon icon-name="close-circle-s"></icon>
                                </button>
                              </div>
                              <div class="input__border"></div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="block__intro-item block__intro-item_md" v-show="showFilters">
                <div class="inline-filters d-none d-md-block">
                  <div class="inline-filters__wrap">
                    <div class="inline-filters__container">
                      <div
                        class="inline-filters__item"
                        v-show="showCityFilter"
                      >
                        <div class="inline-filter">
                          <div class="inline-filter__label">{{ $t('startList.city') }}:</div>
                          <div class="inline-filter__value">
                            <Select
                              v-model="filters.city.val"
                              :value="filters.city.val"
                              :options="filters.city.options"
                              type="simple"
                              size="sm"
                              :searchable="false"
                              cls="multiselect_dropdown-auto"
                              @input="() => {
                                filters.city.mobileVal = filters.city.val; onFiltersChange()
                              } "
                            >
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div
                        class="inline-filters__item"
                        v-show="showClubFilter"
                      >
                        <div class="inline-filter">
                          <div class="inline-filter__label">{{ $t('startList.club') }}:</div>
                          <div class="inline-filter__value">
                            <Select
                              v-model="filters.club.val"
                              :value="filters.club.val"
                              :options="filters.club.options"
                              type="simple"
                              size="sm"
                              :searchable="false"
                              cls="multiselect_dropdown-auto"
                              @input="() => {
                                filters.club.mobileVal = filters.club.val; onFiltersChange()
                              } "
                            >
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="inline-filters inline-filters_mobile d-md-none">
                  <div class="inline-filters__wrap">
                    <div class="inline-filters__container">
                      <div
                        class="inline-filters__item"
                        v-show="showCityFilter"
                      >
                        <mobile-filter
                          v-model="filters.city.mobileVal"
                          :text="getOptionName(filters.city.options, filters.city.val)"
                          :initialValue="filters.city.val"
                          :name="$t('startList.city')"
                          @change="val => { filters.city.val = val; onFiltersChange() }"
                        >
                          <template slot="filter">
                            <Radio
                              v-for="option in filters.city.options"
                              :key="option.id"
                              class="w-100"
                              v-model="filters.city.mobileVal"
                              :value="option.id"
                            >
                              {{ option.name }}
                            </Radio>
                          </template>
                        </mobile-filter>
                      </div>
                      <div
                        class="inline-filters__item"
                        v-show="showClubFilter"
                      >
                        <mobile-filter
                          v-model="filters.club.mobileVal"
                          :text="getOptionName(filters.club.options, filters.club.val)"
                          :initialValue="filters.club.val"
                          :name="$t('startList.club')"
                          @change="val => { filters.club.val = val; onFiltersChange() }"
                        >
                          <template slot="filter">
                            <Radio
                              v-for="option in filters.club.options"
                              :key="option.id"
                              class="w-100"
                              v-model="filters.club.mobileVal"
                              :value="option.id"
                            >
                              {{ option.name }}
                            </Radio>
                          </template>
                        </mobile-filter>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="block__intro-item block__intro-item_md">
                <section class="empty-state" v-show="noMembers">
                  <div class="section__group mt-0">
                    <div class="section__item">
                      {{ $t('startList.noMembers') }}
                    </div>
                  </div>
                </section>
                <section class="empty-state" v-show="!noMembers && isEmpty">
                  <div class="section__group mt-0">
                    <div class="section__item">{{ $t('startList.nothingFound') }}</div>
                  </div>
                </section>
                <div class="loader" v-show="loading"></div>
                <div class="table-container" v-show="!loading && !isEmpty && !noMembers">
                  <table class="table table_default table_striped">
                    <thead class="table__header">
                      <tr>
                        <th>{{ $t('startList.member') }}</th>
                        <th>{{ $t('startList.number') }}</th>
                        <th>{{ $t('startList.club') }}</th>
                        <th v-if="isRelay">{{ $t('startList.team') }}</th>
                        <th v-if="isRelay">{{ $t('startList.stage') }}</th>
                        <th class="text-right">{{ $t('startList.birthYear') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in members"
                        :class="{
                          'table__highlight text-semibold': userId && userId === item.UserId
                        }"
                        :key="item.Id"
                      >
                        <td>
                          <member
                            :userId="item.UserId"
                            :name="item.LastName + ' ' + item.FirstName"
                          >
                            <div class="text-xs d-none d-lg-block">{{ item.City }}
                            </div>
                          </member>
                        </td>
                        <td class="text-xs text-nowrap">
                          <template v-if="item.StartNumber">
                            № <span class="text-lg">{{ item.StartNumber }}</span>
                          </template>
                          <template v-else>--</template>
                        </td>
                        <td class="text-sm">{{ item.Club || '--' }}</td>
                        <td v-if="isRelay" class="text-sm">{{ item.RelayTeam || '--' }}</td>
                        <td v-if="isRelay" class="text-sm">{{ item.RelayStage || '--' }}</td>
                        <td class="text-lg text-right">
                          {{ item.YearBirth }}&nbsp;<span class="text-xs">{{ $t('startList.y')}}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              class="block__item"
              v-show="showPagination && !noMembers"
            >
              <pagination
                :page="pagination.page"
                :totalItems="pagination.totalItems"
                :itemsPerPage="pagination.itemsPerPage"
                :disabled="pagination.disabled"
                @change="changePage"
              >
              </pagination>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Select from '@/components/Select.vue';
import Member from '@/components/Member.vue';
import Pagination from '@/components/Pagination.vue';
import eventsService from '@/services/eventsService';
import MobileFilter from '@/components/MobileFilter.vue';
import {
  isEmpty, filter, debounce, orderBy,
} from 'lodash';

export default {
  name: 'EventMembers',
  components: {
    Select,
    Member,
    Pagination,
    MobileFilter,
  },
  props: {
    event: Object,
    showStartList: Boolean,
    hasMembers: Boolean,
  },
  data() {
    return {
      members: null,
      membersCount: null,
      membersTotalCount: null,
      emptyRaces: [],
      noMembers: false,
      loading: true,
      filters: {
        competition: {
          val: null,
          options: [],
        },
        city: {
          val: null,
          mobileVal: null,
          options: [],
        },
        club: {
          val: null,
          mobileVal: null,
          options: [],
        },
        search: {
          val: null,
        },
      },
      pagination: {
        page: 0,
        disabled: false,
        itemsPerPage: 25,
        totalItems: 0,
      },
      isRelay: false,
    };
  },
  computed: {
    ...mapGetters('settings', ['themeImages']),
    userId() {
      return window.userInfo && window.userInfo.Id;
    },
    infoLoaded() {
      return !isEmpty(this.event);
    },
    showFilters() {
      return this.showCityFilter || this.showClubFilter;
    },
    showCityFilter() {
      return this.filters.city.options.length > 1;
    },
    showClubFilter() {
      return this.filters.club.options.length > 1;
    },
    showPagination() {
      return this.pagination.totalItems > this.pagination.itemsPerPage && !this.loading;
    },
    isEmpty() {
      return this.membersCount < 1 && !this.loading;
    },
  },
  methods: {
    getOptionName(options, id) {
      if (!id) {
        return null;
      }
      for (let i = 0; i < options.length; i += 1) {
        const option = options[i];
        if (option.id === id) {
          return option.name;
        }
      }
      return null;
    },
    clearSearch() {
      this.filters.search.val = '';
    },
    scrollToBlock() {
      const header = document.querySelector('.header .container');
      const yOffset = header ? header.offsetHeight : 0;
      const element = this.$refs.block;
      const y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;

      window.scrollTo({ top: y });
    },
    setCompetitions() {
      let races = filter(
        this.event.Races, (o) => o.sl && !o.dr && (o.pc > 0 || (o.rs === 2 && o.rc !== 0)),
      );

      races = orderBy(races, 'oc');
      races = orderBy(races, 'd', 'desc');

      const competitions = [];

      for (let i = 0; i < races.length; i += 1) {
        const race = races[i];
        competitions.push({
          id: race.c,
          name: race.n,
        });
        if (race.pc < 1) {
          this.emptyRaces.push(race.c);
        }
      }

      this.filters.competition.options = competitions;
      this.filters.competition.val = competitions[0].id;
    },
    changePage(page) {
      this.pagination.page = page;
      this.getMembers(true);
    },
    onFiltersChange() {
      this.pagination.page = 0;
      this.getMembers(true);
    },
    getMembers(scroll) {
      if (this.emptyRaces.indexOf(this.filters.competition.val) !== -1) {
        this.noMembers = true;
        this.loading = false;
        return;
      }

      this.noMembers = false;

      if (this.prevSearch === this.filters.search.val
        && this.prevRace === this.filters.competition.val
        && this.prevClub === this.filters.club.val
        && this.prevCity === this.filters.city.val
        && this.prevPage === this.pagination.page
      ) {
        return;
      }

      this.prevSearch = this.filters.search.val;
      this.prevRace = this.filters.competition.val;
      this.prevClub = this.filters.club.val;
      this.prevCity = this.filters.city.val;
      this.prevPage = this.pagination.page;
      this.loading = true;

      eventsService.getRaceMembers({
        EventCode: this.$route.params.code,
        RaceCode: this.filters.competition.val,
        Count: this.pagination.itemsPerPage,
        Offset: this.pagination.page * this.pagination.itemsPerPage,
        MemberNameFilter: this.filters.search.val,
        ClubeId: this.filters.club.val === 'any' ? null : this.filters.club.val,
        CityId: this.filters.city.val === 'any' ? null : this.filters.city.val,
      })
        .then((res) => {
          const { data } = res;
          this.membersCount = data.RaceMembers.Items.length;
          this.members = data.RaceMembers.Items;
          this.membersTotalCount = data.RaceMembers.TotalCount;
          this.isRelay = data.IsRelay;
          this.pagination.totalItems = data.RaceMembers.TotalCount;
          this.loading = false;
          if (scroll) {
            setTimeout(this.scrollToBlock());
          }
        });
    },
  },
  watch: {
    'filters.search.val': {
      handler() {
        this.debouncedSearch();
      },
    },
    infoLoaded: {
      handler(val) {
        if (!val) {
          return;
        }
        if (!this.showStartList) {
          this.$router.replace({ name: 'Event' });
          return;
        }
        this.setCompetitions();
        if (this.hasMembers) {
          this.getMembers(false);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.debouncedSearch = debounce(this.onFiltersChange, 500);
  },
  activated() {
    if (this.infoLoaded && this.loading && this.hasMembers) {
      this.prevRace = null;
      this.getMembers(false);
    }
  },
};
</script>

<style lang="scss" scoped>
  .event-competitions {

    @media (min-width: breakpoint(sm)) {
      width: 50%;
    }

    @media (min-width: breakpoint(md)) {
      width: 284px;
    }
  }
</style>
